import React from 'react';

import { Translate } from '@change-corgi/core/react/i18n';
import { Box } from '@change-corgi/design-system-legacy/layout';
import { useIsSunriseTheme } from '@change-corgi/design-system-legacy/theme';
import { Heading } from '@change-corgi/design-system-legacy/typography';

import { SupporterCommentCard } from './components/SupporterCommentCard';
import { ViewAllComments } from './components/ViewAllComments';
import { useSupporterComments } from './hooks/useSupporterComments';

export const SupporterVoicesComments: React.FC = () => {
	const {
		data: { supporterComments, petition },
	} = useSupporterComments();
	const isSunriseThemeEnabled = useIsSunriseTheme();

	if (supporterComments.length === 0) {
		return null;
	}

	return (
		<Box>
			<Heading
				as="h3"
				sx={{
					...(isSunriseThemeEnabled
						? {
								fontSize: '24',
							}
						: {
								fontSize: '20',
							}),
					fontWeight: 'normal',
				}}
				my={24}
			>
				<Translate value="corgi.petition_gamma.comments.title" />
			</Heading>
			{supporterComments.map((comment) => {
				return <SupporterCommentCard key={comment.id} supporterComment={comment} petition={petition} />;
			})}

			<ViewAllComments petitionId={petition.id} slug={petition.slug} />
		</Box>
	);
};
